import React from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography, { typographyClasses } from "@mui/material/Typography";
// import useMediaQuery from "@mui/material/useMediaQuery";
// import {  useTheme } from "@mui/material/styles";

import MHFooter from "../components/Layout/MHFooter";
import MHSubscribe from "../components/Layout/MHSubscribe";
// import { useHistory } from "react-router-dom";

import ImageGrid from "../components/Story/ImageGrid";
import { PressMediaComp } from "../components/Story/PressMediaComp";
import { MSISV_PRESS_MEDIA_DATA } from "../utils/summit-data";

const MorganStanley = () => {
  // const theme = useTheme();
  // const matchesMdDown = useMediaQuery(theme.breakpoints.down("md"));

  // const history = useHistory();

  // const membershipPlansDivRef = React.useRef<{
  //   divEl: HTMLDivElement | null;
  // }>({ divEl: null });

  return (
    <React.Fragment>
      <Grid container direction={{ xs: "column", md: "row" }} mb={4}>
        <Grid item xs={12} md={6} bgcolor="#F3F4F6">
          <Stack
            height={500}
            justifyContent="center"
            alignItems="center"
            px={{ xs: 2, md: 10 }}
            sx={{
              "& > p": {
                textAlign: "center",
                pointerEvents: "none",
              },
            }}
          >
            <Typography
              variant="caption"
              textTransform="uppercase"
              fontSize="11px"
              letterSpacing="0.1em"
              lineHeight="230%"
              sx={{
                mb: 5,
              }}
              paragraph
            >
              Press Release
            </Typography>

            <Typography
              variant="h1"
              fontSize={{ xs: "30px", sm: "40px", md: "40px" }}
              textTransform="capitalize"
              sx={{
                mb: 4,
              }}
              paragraph
            >
              Morgan Stanley Backs Caring Africa’s Mission to Transform the Care
              Economy
            </Typography>

            <Typography
              variant="body1"
              align="center"
              color="#194049"
              fontSize="13px"
              lineHeight="185%"
              letterSpacing="0.02em"
              sx={{
                mb: 4,
              }}
              paragraph
            >
              <b className=" font-areaBlack">
                Lagos, Nigeria | September 2025{" "}
              </b>{" "}
              — Caring Africa, a leading organization building the
              infrastructure for Africa’s care economy, has been selected to
              join the{" "}
              <b className=" font-areaBlack">
                {" "}
                Morgan Stanley Inclusive & Sustainable Ventures Collaborative,{" "}
              </b>{" "}
              a prestigious innovation lab recognizing high-impact organizations
              solving systemic global challenges through technology and
              sustainability.
            </Typography>

            {/* <MHButton
              sx={{
                width: "fit-content",
              }}
              onClick={() =>
                membershipPlansDivRef.current?.divEl?.scrollIntoView({
                  behavior: "smooth",
                })
              }
            >
              More Info
            </MHButton> */}
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              "& > img": {
                height: 600,
                width: "100%",
                objectPosition: "bottom",
                objectFit: "cover",
              },
            }}
          >
            <img
              src="https://mh-resources-production.s3.us-west-1.amazonaws.com/TimesSquare.jpeg"
              alt="Banner"
              width="700"
            />
          </Box>
        </Grid>
      </Grid>

      <Box
        py={5}
        px={{ xs: 2, md: 6, lg: 8 }}
        color="primary.main"
        sx={{
          [`& > .${typographyClasses.root}`]: {
            // color: '#EDD5B1',
            textAlign: "center",
          },
        }}
      >
        <Typography
          variant="h1"
          fontSize={{ xs: "38px", md: "50px" }}
          lineHeight="120.5%"
          letterSpacing="-0.04em"
          mb={2}
        >
          Transforming Care Infrastructure in Africa
        </Typography>

        <Typography
          variant="body2"
          fontSize={{ xs: "13px", md: "18px" }}
          lineHeight={{ xs: "200%", md: "169%" }}
          letterSpacing="0.02em"
          width={{ xs: "90%", md: "80%" }}
          mx="auto"
          mb={4}
        >
          Out of thousands of global applicants, Caring Africa was named among
          the 33 organizations selected for the 2025 cohort, and is the{" "}
          <b className=" font-areaBlack">
            {" "}
            only care tech organization from the African continent.
          </b>
          <br />
          <br />
          Through its flagship digital platform,
          <b className=" font-areaBlack"> Caring Blocks,</b> the organization is
          formalizing the continent’s largely informal care sector, connecting
          families to safe, reliable care, while providing caregivers with
          access to training, verification, contracts, and fair pay. The
          platform integrates identity authentication, background checks, care
          payroll, upskilling modules, and real-time support to ensure quality
          care delivery across childcare, eldercare, domestic support, and more.
        </Typography>
      </Box>

      <ImageGrid
        title=""
        demoClass="hidden"
        urlClass="hidden"
        order="order-last lg:order-first"
        imgSrc="https://mh-resources-production.s3.us-west-1.amazonaws.com/Blessing-Headshot-2025.jpg"
        content={`
            “We are building Africa’s care infrastructure, not just a product,”
          said Blessing Adesiyan, Founder & CEO of Caring Africa.
          “Caring Blocks operates as a care infrastructure-as-a-service platform
          that enables governments, employers, and families to onboard, train,
          verify, and compensate care workers with dignity and security. This is
          the foundation for productivity, equity, and sustainable economic
          growth.”
          `}
        content2="hidden"
      />

      <Box
        py={5}
        px={{ xs: 2, md: 6, lg: 8 }}
        color="primary.main"
        sx={{
          [`& > .${typographyClasses.root}`]: {
            // color: '#EDD5B1',
            textAlign: "center",
          },
        }}
      >
        <Typography
          variant="h1"
          fontSize={{ xs: "30px", md: "50px" }}
          lineHeight="120.5%"
          letterSpacing="-0.04em"
          mb={2}
        >
          The Untapped Opportunity in Africa’s Care Economy
        </Typography>

        <Typography
          variant="body2"
          fontSize={{ xs: "13px", md: "18px" }}
          lineHeight={{ xs: "200%", md: "169%" }}
          letterSpacing="0.02em"
          width={{ xs: "90%", md: "80%" }}
          mx="auto"
          mb={4}
        >
          Africa’s informal care economy, long overlooked, represents one of the
          continent’s most underutilized economic engines. With{" "}
          <b className=" font-areaBlack">
            {" "}
            Nigeria projected to become the third most populous country by 2040,
          </b>{" "}
          the demand for trusted, accessible, and professional care is growing
          exponentially, yet infrastructure to deliver it has remained
          fragmented and unregulated.
          <br />
          <br />
          <b className=" font-areaBlack">
            {" "}
            Caring Africa’s solution bridges this gap{" "}
          </b>{" "}
          by leveraging digital tools and scalable systems to formalize care
          work and build trust, for families seeking support, for workers
          seeking dignity, and for policymakers seeking inclusive growth.
          <br />
          <br />
          From{" "}
          <b className=" font-areaBlack">
            {" "}
            employer-sponsored care programs,
          </b>{" "}
          to <b className=" font-areaBlack"> public-private partnerships</b>
          with state governments and global development institutions, Caring
          Africa is also enabling care centers, employers, and governments to
          meet rising demand through a digital ecosystem built for Africa’s
          future.
        </Typography>
      </Box>

      <Box
        py={7}
        px={{ xs: 2, md: 6, lg: 8 }}
        color="primary.main"
        sx={{
          [`& > .${typographyClasses.root}`]: {
            // color: '#EDD5B1',
            textAlign: "center",
          },
        }}
      >
        <Typography
          variant="h1"
          fontSize={{ xs: "30px", md: "50px" }}
          lineHeight="120.5%"
          letterSpacing="-0.04em"
          mb={2}
        >
          A Global Recognition of Care as Infrastructure
        </Typography>

        <Typography
          variant="body2"
          fontSize={{ xs: "13px", md: "18px" }}
          lineHeight={{ xs: "200%", md: "169%" }}
          letterSpacing="0.02em"
          width={{ xs: "90%", md: "80%" }}
          mx="auto"
          mb={4}
        >
          Caring Africa’s selection by Morgan Stanley signals a broader shift in
          how care is understood, not as a private burden, but as critical
          infrastructure for thriving societies. As part of the Collaborative,
          Caring Africa will receive{" "}
          <b className=" font-areaBlack">
            {" "}
            $250,000 in non-dilutive capital, mentorship, and technical support{" "}
          </b>{" "}
          to accelerate its scale, deepen its policy advocacy, and expand market
          adoption of its technology.
          <br />
          <br />
          <i>
            {" "}
            “This recognition from Morgan Stanley affirms that care is no longer
            just a women’s issue or a household matter, it is a tech, business,
            and economic issue,” Adesiyan said. “By making care visible and
            viable, we are unlocking labor force participation, creating jobs,
            and positioning care as a smart investment for Africa’s future.”{" "}
          </i>
        </Typography>
      </Box>

      <Box
        py={7}
        px={{ xs: 2, md: 6, lg: 8 }}
        color="primary.main"
        sx={{
          [`& > .${typographyClasses.root}`]: {
            // color: '#EDD5B1',
            textAlign: "center",
          },
        }}
      >
        <Typography
          variant="h1"
          fontSize={{ xs: "38px", md: "50px" }}
          lineHeight="120.5%"
          letterSpacing="-0.04em"
          mb={2}
        >
          About Caring Africa{" "}
        </Typography>

        <Typography
          variant="body2"
          fontSize={{ xs: "13px", md: "18px" }}
          lineHeight={{ xs: "200%", md: "169%" }}
          letterSpacing="0.02em"
          width={{ xs: "90%", md: "70%" }}
          mx="auto"
          mb={4}
        >
          <b className=" font-areaBlack"> Caring Africa </b> is a nonprofit tech
          and policy organization building Africa’s care infrastructure through
          innovation. Its platform,{" "}
          <b className=" font-areaBlack">Caring Blocks, </b> connects families
          to safe, quality care while formalizing the care workforce,
          transforming an invisible labor market into a visible driver of
          economic growth, resilience, and equity.
          <br />
          <br />
          With hubs in <b className=" font-areaBlack">
            {" "}
            Lagos, London,
          </b> and <b className=" font-areaBlack"> New York,</b> Caring Africa
          is advancing the global care movement, powered by technology, policy,
          community-centered innovation, and partnerships that span employers,
          governments, and global development institutions.
        </Typography>
      </Box>

      {/* <Divider
        variant="middle"
        sx={{
          borderColor: "primary.main",
          width: "91%",
          mx: "auto",
          opacity: 0.1,
          my: 8,
        }}
      /> */}

      <Box className="text-center my-10 overflow-hidden">
        <Typography
          variant="h1"
          fontSize={{ xs: "33px", md: "50px" }}
          lineHeight="120.5%"
          letterSpacing="-0.04em"
          mb={2}
          className="underline"
        >
          Morgan Stanley Press Releases
        </Typography>

        <Grid
          container
          spacing={1}
          className="lg:pl-10 md:gap-4 lg:gap-0 place-content-center"
        >
          {MSISV_PRESS_MEDIA_DATA.map((media, index) => (
            <Grid item xs={12} sm={5} md={4} lg={4} key={index}>
              <PressMediaComp
                image={media.image}
                title={media.title}
                text={media.text}
                link={media.link}
              />
            </Grid>
          ))}
        </Grid>
      </Box>

      <MHSubscribe />

      <MHFooter />
    </React.Fragment>
  );
};

export default MorganStanley;
